import { Button } from '@hologram-dimension/button';
import { Form } from '@hologram-dimension/form';
import { useEffect, type FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PasswordEntry } from '@hologram-hyper-dashboard/components';

interface SetAccountPasswordFormProps {
  cancelButton?: boolean;
  fieldLayoutDirection?: 'column' | 'row';
  onSubmit: Function;
  submitLabel: string;
}

const SetAccountPasswordForm: FC<SetAccountPasswordFormProps> = ({
  cancelButton = false,
  fieldLayoutDirection = 'column',
  onSubmit,
  submitLabel,
}) => {
  /* React Hook Form methods */
  const methods = useForm();

  const {
    formState: { isSubmitting, isSubmitSuccessful },
    handleSubmit,
    setError,
    reset,
  } = methods;

  useEffect(() => {
    reset();
  }, [isSubmitSuccessful, reset]);

  /* Form submit handler */
  const submitHandler = async (data) => {
    // call the provided onSubmit method
    const response = await onSubmit(data);
    // If the external submit handler detects a setPassword API error, it should return a response with a setAccountPasswordFieldError key
    if (response?.setAccountPasswordFieldError) {
      setError('password', {
        type: 'custom',
        message: response.setAccountPasswordFieldError,
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form
        className={`set-account-password-form set-account-password-form--${fieldLayoutDirection}`}
        onSubmit={handleSubmit(submitHandler)}
        footerActions={
          <>
            {cancelButton && (
              <Button variant="secondary" onClick={() => reset()} disabled={isSubmitting}>
                Cancel
              </Button>
            )}
            <Button loading={isSubmitting} name={submitLabel} type="submit">
              {submitLabel}
            </Button>
          </>
        }
      >
        <PasswordEntry fieldLayoutDirection={fieldLayoutDirection} showConfirm showValidation />
      </Form>
    </FormProvider>
  );
};

export default SetAccountPasswordForm;
